// extracted by mini-css-extract-plugin
export default {"button":"AdminPanel_button__Awhd6","organizationContainer":"AdminPanel_organizationContainer__JvyVU","modal":"AdminPanel_modal__95ZyC","modalHeader":"AdminPanel_modalHeader__m4132"};